





































import { ref, defineComponent, toRefs, reactive } from '@vue/composition-api'
import CloseButton from '@/components/custom/CloseButton.vue'
import { editCategory } from '@/shared/api'

export default defineComponent({
  name: 'EditCategory',
  components: {
    CloseButton,
  },
  props: {
    category: Object,
    textbook: Object,
  },
  setup(props, context) {
    const editCategoryForm = ref(null)

    const data = reactive({
      valid: true,
      name: props.category.name,
      nameRules: [
        (v: string) =>
          (!!v && v !== props.category.name) ||
          context.root.$t('editCategoryForm.name.required'),
      ],
    })

    const loading = ref(false)

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = editCategoryForm.value
      form.validate()
      loading.value = true
      try {
        const editedTextbook = await editCategory(
          props.textbook.id,
          props.category.id,
          data.name
        )
        context.emit('category-edited', editedTextbook)
      } catch (e) {
        console.error(e)
      }
      loading.value = false
    }

    return {
      ...toRefs(data),
      loading,
      editCategoryForm,
      submit,
    }
  },
})
